export default __webpack_public_path__ + "static/media/2170.804a05cf.png";